<template>
  <div>
    <div class="admin">
      <!-- enviar por correo -->
      <v-row justify="center" v-if="dialog">
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline font-weight-black"
                >Enviar comprobante por correo</span
              >
            </v-card-title>

            <div class style="padding: 20px">
              <v-text-field
                hint="Ingresa el correo al que deseas enviar el recibo"
                persistent-hint
                v-model="emailAEnviar"
                outlined
                label="Email"
              ></v-text-field>
            </div>

            <div v-if="loaderInDialog" class="pb-5">
              <!-- loader -->
              <div class="text-center">
                <div
                  class="spinner-border text-primary"
                  style="width: 75px; height: 75px"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <!-- /loader -->
            </div>
            <div v-else>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="blue darken-1" text @click="dialog = false"
                  >Cancelar</v-btn
                >
                <v-btn color="primary darken-1" @click="sendBill()"
                  >Enviar</v-btn
                >
              </v-card-actions>
            </div>
          </v-card>
        </v-dialog>
      </v-row>
      <!-- /enviar por correo -->

      <!-- agregar abono -->
      <v-row justify="center" v-if="abono">
        <v-dialog v-model="abono" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline font-weight-black">Agregar abono</span>
            </v-card-title>

            <div class style="padding: 20px">
              <v-text-field
                hint="Ingresa el monto del abono"
                persistent-hint
                v-model="abonoCantidad"
                outlined
                label="Cantidad"
              ></v-text-field>

              <v-select
                class="mt-5"
                :items="metodos_pago"
                hint="Selecciona el método de pago"
                persistent-hint
                label="Método de pago"
                v-model="metodoPagoAbono"
                outlined
              ></v-select>
            </div>

            <div v-if="loaderInAbono" class="pb-5">
              <!-- loader -->
              <div class="text-center">
                <div
                  class="spinner-border text-primary"
                  style="width: 75px; height: 75px"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <!-- /loader -->
            </div>
            <div v-else>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="blue darken-1" text @click="abono = false"
                  >Cancelar</v-btn
                >
                <v-btn color="primary darken-1" @click="sendAbono()"
                  >Enviar</v-btn
                >
              </v-card-actions>
            </div>
          </v-card>
        </v-dialog>
      </v-row>
      <!-- /agregar abono -->

      <div class="fluid-container">
        <div class="row no-gutters">
          <!-- menu admin -->
          <div class="col-3">
            <menu-admin></menu-admin>
          </div>
          <!-- menu admin -->

          <!-- main -->
          <div class="col-9 main pb-5">
            <!-- titulo -->
            <div class="row">
              <div class="col-12 mb-2">
                <div class="title-admin">
                  <h1 class="display-5 font-weight-black">
                    Venta #{{ id_venta }}
                  </h1>

                  <v-btn color="grey" outlined dark to="/admin/ventas">
                    <v-icon left>keyboard_backspace</v-icon>Regresar a ventas
                  </v-btn>
                </div>
              </div>
            </div>
            <!-- /titulo -->

            <!-- tabs wrap -->
            <div class="row">
              <div class="col-12">
                <!-- tabs -->
                <v-tabs background-color="#fff" color="primary" centered grow>
                  <v-tabs-slider></v-tabs-slider>

                  <v-tab href="#venta">Venta</v-tab>
                  <v-tab href="#pagos">Pagos</v-tab>

                  <!-- Ventas tab -->
                  <v-tab-item
                    value="venta"
                    background-color="transparent"
                    class="mt-5"
                  >
                    <!-- acciones -->
                    <div class="acciones mb-5">
                      <v-btn
                        class="mt-3 mr-3"
                        large
                        color="orange"
                        dark
                        @click="abono = !abono"
                      >
                        <v-icon class="mr-3">attach_money</v-icon>Agregar abono
                      </v-btn>

                      <!-- <v-btn
                        class="mt-3 mr-3"
                        large
                        color="grey"
                        outlined
                        @click="dialog = !dialog"
                      >
                        <v-icon class="mr-3">email</v-icon>Enviar por correo
                      </v-btn>-->
                      <v-btn
                        class="mt-3 mr-3"
                        large
                        :loading="loadingEntrega"
                        color="green"
                        dark
                        @click="marcarComoEntregado()"
                      >
                        Marcar como entregado
                      </v-btn>
                      <v-btn
                        class="mt-3"
                        large
                        color="primary"
                        outlined
                        :to="'/admin/print/venta/' + id_venta"
                      >
                        <v-icon class="mr-3">print</v-icon>Ver vista de
                        impresión
                      </v-btn>
                      <v-btn
                        class="mt-3 ml-3"
                        large
                        color="red"
                        outlined
                        dark
                        @click="showAlert()"
                      >
                        <v-icon class="mr-3">delete</v-icon>Eliminar
                      </v-btn>
                    </div>
                    <!-- /acciones -->

                    <div class="row">
                      <!-- left -->
                      <div class="col-8">
                        <h3
                          style="margin: 0; padding: 0"
                          class="subtitle font-weight-black"
                        >
                          Cliente
                        </h3>
                        <!-- cliente -->
                        <div class="cliente box-bg mt-4 mb-5 elevation-3">
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title class="font-weight-bold"
                                >Datos del cliente</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item two-line>
                            <v-list-item-content>
                              <v-list-item-title class="font-weight-bold">
                                <v-icon color="primary" class="mr-2"
                                  >account_circle</v-icon
                                >Nombre
                              </v-list-item-title>
                              <v-list-item-subtitle>{{
                                cliente
                              }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item two-line>
                            <v-list-item-content>
                              <v-list-item-title class="font-weight-bold">
                                <v-icon color="primary" class="mr-2"
                                  >phone</v-icon
                                >Teléfono
                              </v-list-item-title>
                              <v-list-item-subtitle>{{
                                telefono
                              }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item two-line>
                            <v-list-item-content>
                              <v-list-item-title class="font-weight-bold">
                                <v-icon color="primary" class="mr-2"
                                  >email</v-icon
                                >Email
                              </v-list-item-title>
                              <v-list-item-subtitle>{{
                                email
                              }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item three-line expand>
                            <v-list-item-content>
                              <v-list-item-title class="font-weight-bold">
                                <v-icon color="primary" class="mr-2"
                                  >place</v-icon
                                >Dirección
                              </v-list-item-title>
                              <v-list-item-subtitle>{{
                                direccion
                              }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </div>
                        <!-- /cliente -->

                        <!-- productos -->
                        <h3
                          style="margin: 0; padding: 0"
                          class="subtitle font-weight-black mt-5"
                        >
                          Productos y Servicios
                        </h3>

                        <div class="productos-list mt-4">
                          <ul>
                            <li
                              class="elevation-1"
                              v-for="(item, index) in items"
                              :key="item.id"
                            >
                              <div class="left">
                                <div class="imagen">
                                  <div v-if="item.imagen == ''">
                                    <img
                                      src="https://vossmueblerias.com/producto.png"
                                      alt
                                    />
                                  </div>
                                  <div v-else>
                                    <img :src="item.imagen" alt />
                                  </div>
                                </div>
                                <div class="nombre">
                                  <span class="caption">Nombre</span>
                                  <br />
                                  <span class="body-1 font-weight-black">{{
                                    item.nombre
                                  }}</span>
                                </div>
                              </div>
                              <div class="right">
                                <div class="precio">
                                  <span class="caption">Precio</span>
                                  <br />
                                  <span
                                    v-if="item.precio_oferta == '0.00'"
                                    class="body-1 font-weight-black headline"
                                    >${{ item.precio }}</span
                                  >
                                  <span
                                    v-else
                                    class="body-1 font-weight-black headline"
                                    style="text-decoration: line-through;padding-right: 10px;"
                                    >${{ item.precio }}</span
                                  >
                                  <span
                                    v-if="item.precio_oferta != '0.00'"
                                    class="body-1 font-weight-black headline"
                                    style="color:red;"
                                    >${{ item.precio_oferta }}</span
                                  >
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <!-- /productos -->
                      </div>
                      <!-- /left -->

                      <!-- right -->
                      <div class="col-4">
                        <!-- pago -->
                        <div class="pago">
                          <h3
                            style="margin: 0; padding: 0"
                            class="subtitle font-weight-black"
                          >
                            Pago
                          </h3>

                          <div class="cliente box-bg mt-4 mb-5 elevation-3">
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title class="font-weight-bold"
                                  >Datos del pago</v-list-item-title
                                >
                              </v-list-item-content>
                            </v-list-item>

                            <div v-if="estatus_pago == 'completado'">
                              <v-chip class="ml-3 mb-3" color="primary"
                                >Pago completado</v-chip
                              >
                            </div>
                            <div v-else>
                              <v-chip class="ml-3 mb-3" dark color="red"
                                >Pago incompleto</v-chip
                              >
                            </div>

                            <v-list-item two-line>
                              <v-list-item-content>
                                <v-list-item-title class="font-weight-bold"
                                  >Total sin descuento</v-list-item-title
                                >
                                <v-list-item-subtitle>
                                  <span class="font-weight-black body-1"
                                    >${{ montoSinDescuento }}</span
                                  >
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>

                            <v-list-item two-line>
                              <v-list-item-content>
                                <v-list-item-title
                                  class="font-weight-bold"
                                  style="color:red;"
                                  >Descuento</v-list-item-title
                                >
                                <v-list-item-subtitle>
                                  <span
                                    class="font-weight-black body-1"
                                    style="color:red;"
                                    >{{ calcularDescuento() }}</span
                                  >
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>

                            <v-list-item two-line>
                              <v-list-item-content>
                                <v-list-item-title class="font-weight-bold"
                                  >Total del pedido</v-list-item-title
                                >
                                <v-list-item-subtitle>
                                  <span class="font-weight-black body-1"
                                    >${{ monto }}</span
                                  >
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>

                            <v-list-item two-line>
                              <v-list-item-content>
                                <v-list-item-title class="font-weight-bold"
                                  >Abono</v-list-item-title
                                >
                                <v-list-item-subtitle>
                                  <span class="font-weight-black body-1"
                                    >${{ abonos }}</span
                                  >
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>

                            <v-list-item two-line>
                              <v-list-item-content>
                                <v-list-item-title class="font-weight-bold"
                                  >Restante</v-list-item-title
                                >
                                <v-list-item-subtitle>
                                  <div v-if="estatus_pago == 'pendiente'">
                                    <span
                                      class="font-weight-black display-1 red--text"
                                      >${{ monto - abonos }}</span
                                    >
                                  </div>
                                  <div v-else>
                                    <span
                                      class="font-weight-black display-1 primary--text"
                                      >${{ monto - abonos }}</span
                                    >
                                  </div>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>

                            <div v-if="estatus_pago == 'pendiente'">
                              <v-select
                                class="mt-5"
                                :items="metodos_pago"
                                label="Método de pago"
                                v-model="metodo_pago_restante"
                                outlined
                              ></v-select>

                              <v-btn
                                class="mt-1"
                                block
                                color="primary"
                                dark
                                large
                                @click="agregarPagoFinal()"
                                >Agregar pago restante</v-btn
                              >
                            </div>
                          </div>
                        </div>
                        <!-- /pago -->
                      </div>
                      <!-- /right -->
                    </div>
                  </v-tab-item>
                  <!-- /Ventas tab -->

                  <!-- Pagos tab -->
                  <v-tab-item value="pagos" class="mt-5">
                    <div class="row">
                      <div class="col-12">
                        <!-- pagos -->
                        <h3
                          style="margin: 0; padding: 0"
                          class="subtitle font-weight-black mt-5"
                        >
                          Pagos registrados en la orden
                        </h3>

                        <div class="productos-list mt-4">
                          <ul>
                            <li
                              class="elevation-1 mb-5"
                              v-for="(item, index) in pagos"
                              :key="item.id"
                            >
                              <div class="left">
                                <img
                                  src="https://image.flaticon.com/icons/svg/1086/1086741.svg"
                                  alt
                                />
                                <div class="nombre">
                                  <div class="tip">
                                    <h4
                                      class="font-weight-black display-2 mt-0 pt-p mb-0 pb-0"
                                    >
                                      ${{ item.monto }}
                                    </h4>
                                  </div>
                                  <span class="body-1 text-uppercase">{{
                                    item.metodo_pago
                                  }}</span>
                                  <br />
                                  <span
                                    class="caption font-weight-black text-uppercase"
                                    >{{ item.concepto }}</span
                                  >
                                </div>
                              </div>
                              <div class="right">
                                <div class="precio">
                                  <span class="caption">Fecha</span>
                                  <br />
                                  <span
                                    class="display-1 font-weight-black headline"
                                    >{{ item.fecha }}</span
                                  >
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <!-- /pagos -->
                      </div>
                    </div>
                  </v-tab-item>
                  <!-- /Pagos tab -->
                </v-tabs>
                <!-- /tabs -->
              </div>
            </div>
            <!-- /tabs wrap -->
          </div>
          <!-- /main -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import { setTimeout } from "timers";
import myUpload from "vue-image-crop-upload";
const axios = require("axios");
export default {
  data() {
    return {
      //Modal
      dialog: false,
      abono: false,

      //Abono
      abonoCantidad: "",
      metodoPagoAbono: "",
      loaderInAbono: false,

      loaderEntrega: false,

      fecha: "",
      cliente: "",
      telefono: "",
      monto: "",
      montoSinDescuento: "",
      montoConDescuento: "",
      direccion: "",
      pago_final: "",
      email: "",
      loader: true,
      tipo_pago: "",
      abono: "",
      metodo_pago_restante: "Efectivo",
      estatus: "",
      metodos_pago: [
        { text: "Efectivo", value: "Efectivo" },
        { text: "Tarjeta de crédito", value: "Tarjeta de crédito" },
        { text: "Deposito Bancario", value: "Deposito Bancario" },
      ],

      suma_pagos_venta: "",
      cuenta: "",
      totalDescuento: "",

      loaderInDialog: false,

      emailAEnviar: "",

      estatus_pago: "",
      abonos: "",
      total_venta: "",
      items: [],

      pagos: [],

      id_venta: this.$route.params.id,
    };
  },
  methods: {
    saberTotal() {
      this.cuenta = this.monto - this.suma_pagos_venta;
      console.log(this.monto);
      console.log(this.cuenta);

      if (this.cuenta < this.monto) {
        return true;
      } else {
        return false;
      }
    },
    calcularDescuento() {
      if (this.montoSinDescuento != null && this.montoConDescuento != null) {
        let descuento =
          parseFloat(this.montoSinDescuento) -
          parseFloat(this.montoConDescuento);
        return "$-" + descuento;
      } else {
        return "No pudimos calcular el descuento";
      }
    },
    marcarComoEntregado() {
      this.loadingEntrega = true;
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=marcarComoEntregado&id=" +
            this.id_venta
        )
        .then((response) => {
          this.loadingEntrega = false;
          this.$swal({
            type: "success",
            customClass: "arriba",
            title: "La venta se marcó como entregada",
            showConfirmButton: false,
            timer: 1500,
          });
        })
        .catch((error) => console.log(error));
      setTimeout(
        () =>
          router.push({
            name: "ventas_admin",
          }),
        1500
      );
    },
    getVentaData() {
      //Obtenemos los datos del producto
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getVentaData&id=" +
            this.id_venta
        )
        .then((response) => {
          this.fecha = response.data.fecha;
          this.cliente = response.data.cliente;
          this.telefono = response.data.telefono;
          this.monto = response.data.monto;
          (this.montoConDescuento = response.data.monto_descuento),
            (this.montoSinDescuento = response.data.monto_sin_descuento),
            (this.direccion = response.data.direccion);
          this.email = response.data.email;
          this.tipo_pago = response.data.tipo_pago;
          this.abono = response.data.abono;
          this.estatus = response.data.estatus;
        })
        .catch((error) => console.log(error));
    },

    getVentaItems() {
      //Obtenemos los datos del producto
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getVentaItems&id=" +
            this.id_venta
        )
        .then((response) => {
          this.loader = false;
          this.items = response.data;
        })
        .catch((error) => console.log(error));
    },

    //Obtenemos los pagos de la venta
    getPagosVenta() {
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getPagosVenta&id=" +
            this.id_venta
        )
        .then((response) => {
          //Asignamos el valor
          this.pagos = response.data;
        })
        .catch((error) => console.log(error));
    },

    //Enviar por correo el recibo
    sendBill() {
      this.loaderInDialog = true;
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=enviarRecibo&id=" +
            this.id_venta +
            "&email=" +
            this.emailAEnviar
        )
        .then((response) => {
          this.dialog = false;
          this.loaderInDialog = false;
          this.emailAEnviar = "";

          if (response.data == 1) {
            this.$swal({
              type: "success",
              customClass: "arriba",
              title: "La factura se envió correctamente",
              showConfirmButton: true,
            });
          }
        })
        .catch((error) => console.log(error));
    },

    //Obtenemos el estatus del pago de la venta
    getEstatusPagoVenta() {
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getEstatusPagoVenta&id=" +
            this.id_venta
        )
        .then((response) => {
          this.estatus_pago = response.data.estatus;
          this.abonos = response.data.abonos;
          this.total_venta = response.data.total_venta;
        })
        .catch((error) => console.log(error));
    },
    agregarPagoFinal() {
      //Obtenemos los datos del producto
      this.pago_final = this.monto - this.abonos;

      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=agregarPagoFinal&id=" +
            this.id_venta +
            "&monto=" +
            this.pago_final +
            "&metodo_pago=" +
            this.metodo_pago_restante
        )
        .then((response) => {
          this.$swal({
            type: "success",
            customClass: "arriba",
            title: "El pago se agregó correctamente",
            showConfirmButton: false,
            timer: 1500,
          });
        })
        .catch((error) => console.log(error));
      setTimeout(
        () =>
          router.push({
            name: "ventas_admin",
          }),
        1500
      );
    },

    sendAbono() {
      if (this.abonoCantidad == "") {
        this.$swal({
          type: "error",
          customClass: "arriba",
          title: "Agrega la cantidad del abono",
          showConfirmButton: true,
        });
      } else if (this.metodoPagoAbono == "") {
        this.$swal({
          type: "error",
          customClass: "arriba",
          title: "Agrega el método de pago del abono",
          showConfirmButton: true,
        });
      } else {
        this.loaderInAbono = true;
        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=agregarAbono&id=" +
              this.id_venta +
              "&monto=" +
              this.abonoCantidad +
              "&metodo_pago=" +
              this.metodoPagoAbono
          )
          .then((response) => {
            this.loaderInAbono = false;
            this.$swal({
              type: "success",
              customClass: "arriba",
              title: "El pago se agregó correctamente",
              showConfirmButton: true,
            });

            //Traemos datos de nuevo
            this.getPagosVenta();
            this.getVentaData();
            this.getVentaItems();
            this.getEstatusPagoVenta();

            //Reseteamos valores
            this.abonoCantidad = "";
            this.metodoPagoAbono = "";
          })
          .catch((error) => console.log(error));
        /*
        setTimeout(
          () =>
            router.push({
              name: "ventas_admin"
            }),
          1500
        );
        */
      }
    },

    print() {
      window.print();
    },

    showAlert() {
      // Use sweetalert2
      this.$swal({
        title: "Estás seguro que deseas eliminar la venta",
        text: "No podrás deshacer este cambio!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, estoy seguro!",
        cancelButtonText: "No!",
      }).then((result) => {
        if (result.value) {
          //Enviamos petición al servidor
          this.deleteVenta();
        }
      });
    },

    showAlertPago() {
      // Use sweetalert2
      this.$swal({
        title: "Estás seguro que deseas agregar el pago final?",
        text: "No podrás deshacer este cambio!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, estoy seguro!",
        cancelButtonText: "No!",
      }).then((result) => {
        if (result.value) {
          //Enviamos petición al servidor
          this.agregarPagoFinal();
        }
      });
    },
    deleteVenta() {
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=deleteVenta&id=" +
            this.id_venta
        )
        .then((response) => {
          this.$swal({
            type: "success",
            title: "La venta se borró exitosamente",
            showConfirmButton: false,
            timer: 1500,
          });

          setTimeout(
            () =>
              router.push({
                name: "ventas_admin",
              }),
            1500
          );
        })
        .catch((error) => console.log(error));
    },
  },

  mounted() {
    this.getPagosVenta();
    this.getVentaData();
    this.getVentaItems();
    this.getEstatusPagoVenta();
  },
};
</script>
